export function throwIfAlreadyLoaded<T>(parentModule: T, _moduleName: string) {
  if (parentModule) {
    throw new Error(
      '%{moduleName} has already been loaded.  Import Core modules in the appModule only.',
    );
  }
}
